import React from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import InboxList from 'components/Inbox/InboxList';

const InboxTab = ({ campaign, match }) => (
  <React.Fragment>
    <div className="d-flex flex-sm-row flex-column">
      {!!campaign.id &&
      <InboxList campaignId={campaign.id} messageId={match.params.messageId} campaignRedirect={Boolean(campaign.id)} />
        }
    </div>
  </React.Fragment>
);

InboxTab.propTypes = {
  campaign: PropTypes.shape({}).isRequired,
  match: PropTypes.shape({
    params: PropTypes.shape({
      id: PropTypes.string,
    }),
  }).isRequired,
};


export default compose(
  withRouter,
  connect(
    state => ({
      campaign: state.campaign,
    }),
    null,
  ),
)(InboxTab);
